"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatter = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatter extends react_1.Component {
    render() {
        const value = Number(this.props.value);
        let text = value.toLocaleString(undefined, {
            style: "currency",
            currency: "USD"
        });
        if (text === "$NaN" || !value) {
            text = "";
        }
        return React.createElement("span", null, text);
    }
}
exports.NumberFormatter = NumberFormatter;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/ledgerReport/number-formatter.tsx
// module id = 3720
// module chunks = 0